import React from 'react';

import { View } from 'react-native';

import { BottomSheet } from 'components/bottom-sheet';

import { MenuReorderCard } from '../menu-reorder-card';
import { MenuReorderItemsList } from '../menu-reorder-items-list';

import { contentStyles } from './styled';
import { MenuReorderDetailsDrawerProps } from './types';

export const MenuReorderDetailsDrawer = ({
  showDrawer,
  toggleDetailsDrawer,
  order,
  openDetailEventMessage,
}: MenuReorderDetailsDrawerProps) => {
  return (
    <BottomSheet
      onOpenEventMessage={openDetailEventMessage}
      isOpen={showDrawer}
      onClose={toggleDetailsDrawer}
    >
      <View style={contentStyles.content}>
        <MenuReorderItemsList
          orderEntries={order.orderEntries}
          ListHeaderComponent={() => (
            <MenuReorderCard
              order={order}
              toggleDetailsDrawer={toggleDetailsDrawer}
              drawerIsOpen={showDrawer}
            />
          )}
        />
      </View>
    </BottomSheet>
  );
};
